/**
 * Adblock plugin: coarse blocker detection via bait element.
 */
import type { PluginContext } from "../lib/types";

import { registerPlugin } from "./register";

registerPlugin("adblock", (ctx: PluginContext) => {
  const detect = () => {
    if (!ctx.canTrackCategory("adblock_signals")) return;

    const bait = document.createElement("div");
    bait.className = "adsbox ad adsbanner ad-placement";
    bait.setAttribute(
      "style",
      "position:absolute;left:-9999px;top:-9999px;height:10px;width:10px;",
    );
    document.body.appendChild(bait);

    const hidden =
      bait.offsetHeight === 0 ||
      bait.offsetWidth === 0 ||
      getComputedStyle(bait).display === "none";
    bait.remove();

    ctx.track("adblock_detected", {
      detected: hidden,
      method: "bait_element",
    });
  };

  return {
    onInit() {
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", detect, { once: true });
      } else {
        detect();
      }
    },
  };
});
